import { defineStore } from 'pinia';
import { useAxios } from '@/features/shared/axios';
import { useCommonStore } from '@/features/shared/commonStore';
import { getLink, hasLink } from '@/features/shared/LinkHelper';
import { Link, Resource } from '@/features/shared/models';
import { IssueFormMetadataRels } from './rels';
import { IssueFormFieldSummary, IssueFormFieldTypeFields, IssueFormFieldTypes } from './issueFormMetadataModels';

const requestConfig = { headers: { 'X-Issue-Provider': 'Zendesk' } };

export const useIssueFormMetadataStore = defineStore('issue-form-metadata', {
    state: () => ({
        types: new Array<IssueFormFieldTypeFields>(),
        fields: new Array<IssueFormFieldSummary>(),
        fieldTypesLinks: new Array<Link>()
    }),
    getters: {
        canEditFieldTypes: state => hasLink(IssueFormMetadataRels.SetIssueFormFieldType, state.fieldTypesLinks)
    },
    actions: {
        async loadFieldTypes() {
            const common = useCommonStore();
            const axios = useAxios();
            const link = common.getLink(IssueFormMetadataRels.GetIssueFormFieldTypes);

            if (!link) throw new Error(`${IssueFormMetadataRels.GetIssueFormFieldTypes} link not found`);

            const response = await axios.requestByLink<Resource<IssueFormFieldTypes>>(link, requestConfig);
            this.types = response.data.data?.types ?? [];
            this.fields = response.data.data?.fields ?? [];
            this.fieldTypesLinks = response.data.links;
        },
        async saveFieldType(fieldType: IssueFormFieldTypeFields) {
            const axios = useAxios();
            const link = getLink(IssueFormMetadataRels.SetIssueFormFieldType, this.fieldTypesLinks);

            await axios.requestByLink(link, { ...requestConfig, data: fieldType });
        }
    }
});
